import React from 'react'
import AdminReport from '../Components/Admin/AdminReport'

const AdminReportPage = () => {
  return (
    <AdminReport />
  )
}

export default AdminReportPage